<template>
  <v-card class="w-100" min-height="365px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="120"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-card-title>
      <v-row no-gutters>
        <v-icon large class="pr-2">mdi-calendar-today</v-icon>
        <h3>{{ $t("publicHolidayManagement") }}</h3>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div class="d-flex justify-center">
        <v-col cols="7"
          ><v-select v-model="selectedState" dense hide-details height="20px" :items="states" item-text="name" item-value="value"></v-select>
        </v-col>
      </div>
      <div class="d-flex justify-center">
        <v-col cols="4"><v-text-field v-model="selectedYear" :label="$t('year')" prepend-icon="mdi-calendar" type="number"></v-text-field> </v-col>
      </div>

      <div>
        <v-data-table
          :items="publicHolidays"
          hide-default-header
          :headers="holidaysTableHeader"
          hide-default-footer
          :page.sync="page"
          @page-count="pageCount = $event"
          :items-per-page="itemsPerPage"
          style="min-height: 240px"
        >
          <template v-slot:item.date="{ item }">
            <span>
              {{ $moment(item.date).format("DD.MM.YYYY") }}
            </span>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row justify="end" no-gutters>
        <v-btn rounded style="color: white" class="mr-2 mb-2" color="#990000" @click="showHolidayDialog = true">{{ $t("importHolidays") }}</v-btn>
        <v-btn rounded style="color: white" class="ml-2 mb-2" color="#990000" @click="showHolidayAdministration = true">{{ $t("editPublicHolidays") }}</v-btn>
      </v-row>
    </v-card-actions>
    <HolidayImportDialog
      v-if="showHolidayDialog"
      :state="selectedState"
      @close="(showHolidayDialog = false), (selectedYear = $event.selectedYear), (selectedState = $event.selectedLand)"
      @importHolidayDays="getHolidays"
      :sapHolidays="allHolidays"
      :year="selectedYear"
    />
    <HolidaysAdministration v-if="showHolidayAdministration" :state="selectedState" :year="selectedYear" @close="closeHolidayAdministration($event)" />
  </v-card>
</template>

<script>
export default {
  name: "MiniPublicHolidaysAdministration",
  data: (vm) => ({
    publicHolidays: [],
    showHolidayDialog: false,
    showHolidayAdministration: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 5,
    loaderOverlay: false,
    allHolidays: [],
    selectedState: null,
    selectedYear: vm.$moment().format("YYYY"),
    states: []
  }),

  components: {
    HolidayImportDialog: () => import("../Administration/HolidayImportDialog"),
    HolidaysAdministration: () => import("../Administration/HolidaysAdministration.vue")
  },
  props: {
    holidays: {
      type: Array
    }
  },
  computed: {
    holidaysTableHeader: function () {
      return [
        {
          text: this.$t("date"),
          value: "date",
          hint: this.$t("date"),
          sortable: true,
          class: "primary--text font-weight-bold subheading"
        },
        {
          text: this.$t("name"),
          value: "name",

          hint: this.$t("name"),
          sortable: true,
          class: "primary--text font-weight-bold subheading"
        }
      ];
    }
  },
  created: async function () {
    this.states = this.$store.getters["server/states"];
    await this.getHolidays();
  },
  methods: {
    async importHolidayDays(items) {
      this.loaderOverlay = true;
      let newHolidays = [];
      for (let holiday of items) {
        let sameHoliday = this.publicHolidays.some((item) => item.name == holiday.name);
        if (!sameHoliday)
          newHolidays.push({
            name: holiday.name,
            date: holiday.date,
            formattedDate: holiday.formattedDate,
            new: true
          });
      }
      this.publicHolidays = [...this.publicHolidays, ...newHolidays];
      this.loaderOverlay = false;
    },
    async getHolidays() {
      await this.$store
        .dispatch("holidayInfo/getPublicHolidays")
        .then((res) => {
          if (res.status == 200) {
            let holidays = res.data.holidays;
            let vm = this;
            holidays.sort(function (o1, o2) {
              return vm.$moment(o1.date).isBefore(vm.$moment(o2.date)) ? -1 : vm.$moment(o1.date).isAfter(vm.$moment(o2.date)) ? 1 : 0;
            });

            let startOfYear = this.$moment(this.selectedYear, "YYYY").startOf("year");
            let endOfYear = this.$moment(this.selectedYear, "YYYY").endOf("year");
            this.allHolidays = holidays;
            if (this.selectedState == null) {
              let holiday = holidays.find((item) => item.state != null);

              this.selectedState = this.$store.getters["server/defaultState"] != null ? this.$store.getters["server/defaultState"] : holiday.state;
            }

            this.publicHolidays = holidays.filter(
              (item) =>
                this.$moment(item.date).isSameOrAfter(startOfYear) && this.$moment(item.date).isSameOrBefore(endOfYear) && item.state == this.selectedState
            );
          }
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    closeHolidayAdministration(event) {
      this.showHolidayAdministration = false;
      this.selectedState = event.state;
      this.selectedYear = event.year;
      this.loaderOverlay = true;
      this.getHolidays();
      this.loaderOverlay = false;
    }
  },
  watch: {
    selectedState: function (val) {
      let startOfYear = this.$moment(this.selectedYear, "YYYY").startOf("year");
      let endOfYear = this.$moment(this.selectedYear, "YYYY").endOf("year");
      this.publicHolidays = this.allHolidays.filter(
        (item) => this.$moment(item.date).isSameOrAfter(startOfYear) && this.$moment(item.date).isSameOrBefore(endOfYear) && item.state == this.selectedState
      );
    },
    selectedYear: function (val) {
      let startOfYear = this.$moment(this.selectedYear, "YYYY").startOf("year");
      let endOfYear = this.$moment(this.selectedYear, "YYYY").endOf("year");
      this.publicHolidays = this.allHolidays.filter(
        (item) => this.$moment(item.date).isSameOrAfter(startOfYear) && this.$moment(item.date).isSameOrBefore(endOfYear) && item.state == this.selectedState
      );
    }
  }
};
</script>

<style></style>
